<template>
  <section class="ui-pause">
    <span class="ui-pause__bg" />
    <div class="ui-pause__banner">
      <img src="/img/misc/lettuce.png" alt="lettuce pause">
      <p>PAUSE</p>
    </div>

    <div class="ui-pause__content">
      <CurrentScore class="ui-pause__score" />

      <div class="ui-pause__buttons">
        <ButtonRounded :content="$translate('menu').resume" action="resumeGame" />
        <!-- <ButtonRounded class="button--right" :content="$translate('menu').leave" action="leaveGame" /> -->
      </div>
    </div>
  </section>
</template>

<script>
import CurrentScore from '@/components/CurrentScore.vue';
import ButtonRounded from '@/components/ButtonRounded.vue';

export default {
  name: 'UIpause',

  components: {
    CurrentScore,
    ButtonRounded,
  },
};
</script>

<style lang="scss" scoped>
.ui-pause {
  color: $color-white;

  &__bg {
    @include full();

    background-color: rgba($color-brown, 0.7);
  }

  &__banner {
    position: absolute;
    top: 5.5vh;
    width: 22vw;
    min-width: 220px;
    left: 50%;

    img {
      display: block;
      position: relative;
      width: 100%;
    }

    p {
      position: absolute;
      bottom: 40%;
      left: 0;
      width: 100%;

      text-align: center;
      font-weight: bold;
      @extend %font-score;
    }
  }

  &__content {
    position: absolute;
    bottom: 20px;
    width: 100%;
    height: 100%;
    padding-top: 24vh;
  }

  &__buttons,
  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
  }

  &__score {
    margin: 5vh 0 20vh;
  }

  &__buttons {
    margin-bottom: 5vh;

    > *:first-child {
      margin-bottom: 20px;
    }
  }

  @include mq(ipadL) {
    &__buttons {
      width: 26vw;
      min-width: 400px;
      margin-bottom: 0;
    }
  }

  @include mq(ds) {
    &__score {
      margin: 10vh 0 20vh;
    }
  }
}
</style>
